import urlJoin from 'url-join';
import { useLeadStore, usePipedriveStore } from "..";
import { appBaseUrl } from "../appConfig";
import { showErrorToast, showSuccessToast } from "../components/ToastContainer";
import ILead, { ILeadEditState } from "../interfaces/ILead";
import { leadStatusToString } from "../utils/enumUtils";
import useCurrentOrFallbackPipedriveUserId from "./useCurrentOrFallbackPipedriveUserId";

const useLeadUpdate = (): (lead: ILead, leadState: ILeadEditState) => Promise<void> => {
    const leadStore = useLeadStore();
    const pipedriveStore = usePipedriveStore();
    const pipedriveUserId = useCurrentOrFallbackPipedriveUserId();

    return async (lead: ILead, leadState: ILeadEditState): Promise<void> => {
        leadStore.setIsLeadsLoading().updating(true);
        try {
            const pipedriveCompanyId = await pipedriveStore.getOrCreatePipedriveOrganizationId(leadState.pipedriveCompanyName);
            const leadUrl = urlJoin(appBaseUrl, "leads", lead.id.toString());
            const notes = `${lead.address} ${leadUrl}`;

            let activityId = leadState.activityId;
            if (!leadState.activityId && leadState.isSetReminder)
                activityId = await pipedriveStore.createActivity(leadState.activityDueDate!, leadState.activitySubject!, notes, pipedriveUserId, pipedriveCompanyId);

            if (leadState.activityId && leadState.isSetReminder)
                await pipedriveStore.updateActivity(leadState.activityId, leadState.activityDueDate!, leadState.activitySubject!, notes, pipedriveUserId, pipedriveCompanyId);

            if (leadState.activityId && !leadState.isSetReminder) {
                await pipedriveStore.markActivityAsDone(leadState.activityId);
                activityId = null;
            }

            await leadStore.updateLead({
                ...lead,
                ...leadState,
                pipedriveCompanyId: pipedriveCompanyId,
                activityId: activityId,
            });

            if (lead.status !== leadState.status)
                await leadStore.createLeadNote(lead.id, `Status: ${leadStatusToString(lead.status)} → ${leadStatusToString(leadState.status)}`);

            showSuccessToast();
        } catch (e) {
            showErrorToast();
            throw e;
        } finally {
            leadStore.setIsLeadsLoading().updating(false);
        }
    };
};

export default useLeadUpdate;